export var PharmacyRequestStatus;
(function (PharmacyRequestStatus) {
    PharmacyRequestStatus["Active"] = "active";
    PharmacyRequestStatus["Stopped"] = "stopped";
    PharmacyRequestStatus["Cancelled"] = "cancelled";
    PharmacyRequestStatus["EnteredInError"] = "enteredInError";
})(PharmacyRequestStatus || (PharmacyRequestStatus = {}));
export var PharmacyRequestAllowedActions;
(function (PharmacyRequestAllowedActions) {
    PharmacyRequestAllowedActions["Cancel"] = "cancel";
    PharmacyRequestAllowedActions["Stop"] = "stop";
    PharmacyRequestAllowedActions["EnteredInError"] = "enteredInError";
    PharmacyRequestAllowedActions["Print"] = "print";
})(PharmacyRequestAllowedActions || (PharmacyRequestAllowedActions = {}));
